import { useEffect, useMemo, useState } from "react";
import {
  BLOG_READING_THEME_STORAGE_KEY,
  DEFAULT_DARK_READING_THEME_ID,
  DEFAULT_LIGHT_READING_THEME_ID,
  getBlogReadingThemeById,
} from "../constants/blogReadingThemes";

const getDefaultThemeId = () => {
  if (typeof document === "undefined") return DEFAULT_DARK_READING_THEME_ID;

  return document.body.classList.contains("light-theme")
    ? DEFAULT_LIGHT_READING_THEME_ID
    : DEFAULT_DARK_READING_THEME_ID;
};

const getInitialThemeId = () => {
  if (typeof window === "undefined") return DEFAULT_DARK_READING_THEME_ID;

  const storedThemeId = window.localStorage.getItem(
    BLOG_READING_THEME_STORAGE_KEY,
  );

  return getBlogReadingThemeById(storedThemeId)
    ? storedThemeId
    : getDefaultThemeId();
};

export const useBlogReadingTheme = () => {
  const [selectedThemeId, setSelectedThemeId] = useState(getInitialThemeId);

  const selectedTheme = useMemo(() => {
    return (
      getBlogReadingThemeById(selectedThemeId) ||
      getBlogReadingThemeById(getDefaultThemeId())
    );
  }, [selectedThemeId]);

  useEffect(() => {
    if (typeof window === "undefined" || !selectedTheme) return;

    window.localStorage.setItem(
      BLOG_READING_THEME_STORAGE_KEY,
      selectedTheme.id,
    );
  }, [selectedTheme]);

  return {
    selectedTheme,
    selectedThemeId: selectedTheme?.id || DEFAULT_DARK_READING_THEME_ID,
    setSelectedThemeId,
  };
};
